export const MAX_REPORT_ITEMS = 1000;

export const ReportItemType = {
  SYNTHESIS_TREE: 'synthesis-tree',
  REACTION: 'reaction',
} as const;
